import React, { FC } from "react";
import { useNavigate, useNavigation } from "react-router-dom";
import { ExtractItem } from "src/utils/extractDescription";
import { PixResponse } from "./ProofResponses";
import transactionLabel from "src/utils/transactionLabel";

import {
  ButtonWrapper,
  CloseIcon,
  DownloadIcon,
  InfoModal,
  Modal,
  ModalContent,
  ModalHeader,
  Section,
  SectionAccountinfo,
  SectionCPNJ,
  SectionItem,
  SectionPayerName,
  SectionTitle,
} from "../ModalConfirmOperation/styles";
import toLocaleAmount from "src/utils/toLocaleAmount";
import dateToLine from "src/utils/dateToLine";
import { documentFormatted } from "src/utils/documentFormatted";
import { Button } from "../button";
import { config } from "src/config";
import { useAuth } from "src/hooks/auth";

export const P2P: FC<{ data: ExtractItem; closeModal: () => void }> = ({
  data,
  closeModal,
}) => {
  const { user } = useAuth();

  const txType = data?.type?.toLowerCase();

  console?.log(txType);

  const naviagate = useNavigate();

  if (!txType?.includes("pix")) {
    naviagate("/extract");
  }

  function printPDF() {
    if (!data) return null;

    const receiptString = JSON?.stringify(data);

    localStorage?.setItem("temp_receipt_to_print", receiptString);

    window?.open(`${config?.FRONTEND_URL}/PDF`);
  }

  const response = data?.response as PixResponse;

  const label = transactionLabel(data);

  console?.log(response);

  const beneficiaryName = response?.proof?.beneficiary?.holder?.name
    ? response?.proof?.beneficiary?.holder?.name
    : data?.direction == "in"
    ? user?.name
    : "Desconhecido";

  return (
    <>
      <ModalHeader>
        <div>
          <span>{label}</span>
          <button onClick={closeModal}>
            <CloseIcon />
          </button>
        </div>
      </ModalHeader>
      <ModalContent>
        <InfoModal>
          <div>
            <span>{response?.proof?.beneficiary?.holder?.name}</span>
            <p>R$ {toLocaleAmount(data?.amount)}</p>
          </div>
          <span>{dateToLine(data?.created_at)}</span>
        </InfoModal>
        <Section>
          <SectionTitle>Pagador</SectionTitle>
          <SectionPayerName>
            <span>NOME</span>
            <p>{response?.proof?.payer?.holder?.name}</p>
          </SectionPayerName>
          <SectionCPNJ>
            <span>
              {response?.proof?.payer?.holder?.document?.length > 11
                ? "CNPJ"
                : "CPF"}
            </span>
            <p>{documentFormatted(response?.proof?.payer?.holder?.document)}</p>
          </SectionCPNJ>
          <SectionItem>
            <span>INSTITUIÇÃO</span>
            <p>{response?.proof?.payer?.participant?.name}</p>
          </SectionItem>
          <SectionAccountinfo>
            <SectionItem>
              <span>AG</span>
              <p>{response?.proof?.payer?.branch}</p>
            </SectionItem>
            <SectionItem>
              <span>CONTA</span>
              <p>{response?.proof?.payer?.number}</p>
            </SectionItem>
          </SectionAccountinfo>
        </Section>
        <Section>
          <SectionTitle>Favorecido</SectionTitle>
          <SectionItem>
            <span>NOME</span>
            <p>{beneficiaryName}</p>
          </SectionItem>
          <SectionItem>
            <span>
              {response?.proof?.beneficiary?.holder?.document?.length > 11
                ? "CNPJ"
                : "CPF"}
            </span>
            <p>
              {/* @ts-ignore */}
              {documentFormatted(
                response?.proof?.beneficiary?.holder?.document
              )}
            </p>
          </SectionItem>
          <SectionItem>
            <span>INSTITUIÇÃO</span>
            <p>{response?.proof?.beneficiary?.participant?.name}</p>
          </SectionItem>
          <SectionAccountinfo>
            <SectionItem>
              <span>AG</span>
              <p>{response?.proof?.beneficiary?.branch}</p>
            </SectionItem>
            <SectionItem>
              <span>CONTA</span>
              <p>{response?.proof?.beneficiary?.number}</p>
            </SectionItem>
          </SectionAccountinfo>
        </Section>
        <ButtonWrapper>
          <Button
            handleFunction={printPDF}
            Icon={DownloadIcon}
            title="Baixar Comprovante"
          />
        </ButtonWrapper>
      </ModalContent>
    </>
  );
};
